import { Typography } from "@mui/material";

import { Link } from "components/html/Link";

import { i18n } from "services/i18nService";
import {
  APP_CREDS_ID,
  CUSTOM_APP_ID,
  CONNECTOR_APP_ID,
} from "services/sosInventoryService/cart/schema";

const noNumberLi = {
  listStyleType: "none",
  pl: "1.2em",
  textIndent: "-1.2em",
  paddingTop: "4px",
};

export function Shopify(props) {
  const { shopifyAppType } = props;
  const isAppCreds = shopifyAppType === APP_CREDS_ID;
  const isCustomShopifyApp = shopifyAppType === CUSTOM_APP_ID;
  const isShopifyConnectorApp = shopifyAppType === CONNECTOR_APP_ID;

  return (
    <>
      <Typography sx={{ mt: 1 }}>
        {i18n("cart.Shopify.instructions.header")}
      </Typography>
      <ol>
        <li>{i18n("cart.Shopify.instructions.1")}</li>
        <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2`)}</li>
        {!isShopifyConnectorApp && !isAppCreds && (
          <ol style={{ paddingTop: "4px", paddingBottom: "8px" }}>
            <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2.1`)}</li>
            <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2.2`)}</li>
            <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2.3`)}</li>
            <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2.4`)}</li>
            <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2.5`)}</li>
            <li>{i18n(`cart.Shopify.instructions.${shopifyAppType}.2.6`)}</li>
            {isCustomShopifyApp && (
              <li style={noNumberLi}>
                {i18n("cart.Shopify.instructions.custom.2.6.note")}
              </li>
            )}
          </ol>
        )}
        {isAppCreds && (
          <ol style={{ paddingTop: "4px", paddingBottom: "8px" }}>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.1")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.2")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.3")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.4")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.5")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.6")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.7")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.8")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.9")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.10")}</li>
            <li>{i18n("cart.Shopify.instructions.appcreds.2.11")}</li>
          </ol>
        )}
        {isShopifyConnectorApp && (
          <ol style={{ paddingTop: "4px", paddingBottom: "8px" }}>
            <li>{i18n(`cart.Shopify.instructions.connector.2.1`)}</li>
            <li>{i18n(`cart.Shopify.instructions.connector.2.2`)}</li>
            <li>{i18n(`cart.Shopify.instructions.connector.2.3`)}</li>
            <li>{i18n(`cart.Shopify.instructions.connector.2.4`)}</li>
          </ol>
        )}
        <li>{i18n("cart.Shopify.instructions.3")}</li>
        <li>
          {i18n("cart.Shopify.instructions.4.1")}{" "}
          <Link
            component="a"
            rel="noreferrer"
            href="https://help.sosinventory.com/home"
            target="_blank"
          >
            {i18n("cart.link.instructions.SosHelpCenter")}
          </Link>{" "}
          {i18n("cart.Shopify.instructions.4.2")}
        </li>
        <li style={noNumberLi}>{i18n("cart.Shopify.instructions.note")}</li>
      </ol>
    </>
  );
}
